import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Fluent from "i18next-fluent"
import Backend from "i18next-fluent-backend"
import { initReactI18next } from "react-i18next"

import { DEFAULT_NAMESPACE, I18N_NAMESPACES, SUPPORTED_LANGUAGES } from "./constants"
import { installI18nDevLogging, installI18nDiagnostics, installI18nDocumentLanguage } from "./utils"

installI18nDiagnostics(i18n)
installI18nDevLogging(i18n)
installI18nDocumentLanguage(i18n)

i18n
  .use(Fluent)
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Every locale ships every English key (check:locales), so only English itself needs the English fallback.
    fallbackLng: (code?: string) => (code && !code.startsWith("en") ? [] : ["en"]),
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true,

    ns: I18N_NAMESPACES,
    defaultNS: DEFAULT_NAMESPACE,

    // Normalize browser locales like en-US to the supported language folder.
    load: "languageOnly",

    // The detector only reads: the last settled choice is written by the language controller, so a
    // Telegram-language fallback applied before settings resolve never becomes the next cold start.
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      convertDetectedLanguage: (lng: string) => lng.split(/[-_]/)[0],
      caches: []
    },

    debug: import.meta.env.DEV,

    // Dev serves raw .ftl for HMR; production loads the precompiled, content-hashed JSON that
    // vite.config.ts emits under /assets/, which skips the @fluent/syntax parse on every open.
    backend: import.meta.env.DEV
      ? { loadPath: "/locales/{{lng}}/{{ns}}.ftl", crossDomain: true }
      : {
          loadPath: `/assets/locales/${__LOCALES_VERSION__}/{{lng}}/{{ns}}.json`,
          crossDomain: true,
          parse: (data: string) => JSON.parse(data) as object
        },

    interpolation: {
      escapeValue: false // React handles escaping
    },

    react: {
      useSuspense: false
    }
  })
  .catch((error: unknown) => {
    console.error("[i18n] Failed to initialize:", error)
  })

export default i18n
